// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"0":"f8dd46da","242":"55b822b1","379":"828ec6e6","443":"0b28c53d"}[chunkId] + ".css";
};